// extracted by mini-css-extract-plugin
export var container = "_ly-0";
export var dotAnimation = "_ly-2";
export var dotsLoading = "_ly-1";